import { Component, Input, OnInit } from '@angular/core';
import { FeatureService } from '../../shared/services/feature.service';
import { ToastrService } from 'ngx-toastr';
@Component({
    selector: 'feature',
    templateUrl: './feature.component.html',
    standalone: false
})

export class FeatureComponent implements OnInit {
  @Input() name: string = "";
  visible = false;

  constructor(private featureService: FeatureService, private toastrService: ToastrService) {
     
  }

  ngOnInit(): void {
    this.featureService.IsFeatureEnabled(this.name)
      .subscribe(data => {
        if (data) {
          this.visible = data
        }
        else {
          this.visible = false;
        }
      }, error => {
        // An error has occured. For safe measure, hide the feature.
        this.visible = false;

        // Log to the console since we do not want to alert the user to a feature they may not have
        console.log(`An error has occured checking if the following feature is enabled: ${this.name}`)
      });
  }
}
